const REGEXP_DATE_FR = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_DE_NAISSANCE_FR =
    /^(0[0-9]|[1-2][0-9]|3[0-1])\/(0[0-9]|1[0-2])\/((19[0-9]{2})|2[0-9]{3})$/;
export const REGEXP_DATE_DE_NAISSANCE_FR_AVANT_1900 =
    /^(0[0-9]|[1-2][0-9]|3[0-1])\/(0[0-9]|1[0-2])\/((1[0-9]{3})|2[0-9]{3})$/;

export default REGEXP_DATE_FR;
